import curry from "../lib/core/functional/curry";

const NAME_MAP = new Map();

function trytoFindElementById(name) {
    return document.querySelector(`[id^="s${name.replace(/ /gi, "_")}"]`);
}

function getJsDescriptionElement(requestingElement) {
    const closest = requestingElement.closest(`[name]`);
    if (!closest) {
        return null;
    }

    const name = closest.getAttribute("name");
    if (NAME_MAP.has(name)) {
        return NAME_MAP.get(name);
    }

    let container;

    const brick = document.querySelector(`.js-brick-description[data-name="${name}"]`);
    if (brick) {
        container = brick.nextElementSibling;
    } else {
        container = trytoFindElementById(name);
    }

    if (!container) {
        return null;
    }

    let debugHolder = container.querySelector(".rm-lddebugger-serversidetimings-holder");
    if (!debugHolder) {
        debugHolder = document.createElement("div");
        debugHolder.classList.add("rm-lddebugger-serversidetimings-holder");
        container.prepend(debugHolder);
        container.classList.add("rm-lddebugger-anchor-holder");
    }

    NAME_MAP.set(name, debugHolder);
    return debugHolder;
}

const getContainer = curry(function getContainer(debugClass, title, requestingElement) {
    const debugHolder = getJsDescriptionElement(requestingElement);
    if (!debugHolder) {
        return null;
    }

    const className = `rm-lddebugger-serversidetimings-${debugClass}`;

    const debugElement = debugHolder.querySelector(`.${className}`);
    if (debugElement) {
        return debugElement;
    }

    const timeHolder = document.createElement("span");
    timeHolder.classList.add("rm-lddebugger-serversidetimings-element", className);
    timeHolder.dataset.allTimings = "";
    timeHolder.textContent = "0";
    timeHolder.title = title;

    debugHolder.appendChild(timeHolder);

    return timeHolder;
});

function parseTime(time) {
    const [hours, minutes, secondsAndMilis] = time.split(":");
    return (
        parseInt(hours, 10) * 3600 + parseInt(minutes, 10) * 60 + parseFloat(secondsAndMilis, 10)
    );
}

function updateTimings(time, element) {
    const oldTime = parseFloat(element.textContent);
    const numericTime = parseTime(time);
    if (oldTime) {
        if (numericTime > oldTime) {
            element.textContent = numericTime;
        }
    } else {
        element.textContent = numericTime;
    }
    element.dataset.allTimings = element.dataset.allTimings + `${time},`;
}

function getSkeletonDebugUrl() {
    const dataUrl = new URL(document.location.href);
    const dataQueryParams = new URLSearchParams(dataUrl.search);
    dataQueryParams.set("skeleton_logging", "display");
    dataUrl.search = `?${dataQueryParams.toString()}`;
    return dataUrl;
}

function getData() {
    const url = getSkeletonDebugUrl();
    return fetch(url).then((res) => {
        if (res.ok) {
            return res.text();
        } else {
            throw new Error("Invalid Response");
        }
    });
}

function parseXml(content) {
    const parser = new DOMParser();
    return parser.parseFromString(content, "text/xml");
}

const handleElement = curry(function handleElement(getContainer, element) {
    const debugUI = getContainer(element);
    if (!debugUI) {
        return null;
    }

    const timeSpend = element.getAttribute("time_spent");
    updateTimings(timeSpend, debugUI);
});

const handleDataProcessingTime = handleElement(
    getContainer("data-processing", "Data processing time")
);
const handleModelProcessingTime = handleElement(
    getContainer("model-processing", "Model processing time")
);
const handleRenderProcessingTime = handleElement(
    getContainer("render-processing", "Render processing time")
);

function renderUI(debugDocument) {
    debugDocument
        .querySelectorAll("data_processing [name] > done[time_spent]")
        .forEach(handleDataProcessingTime);
    debugDocument
        .querySelectorAll("model_processing [name] > done[time_spent]")
        .forEach(handleModelProcessingTime);
    debugDocument
        .querySelectorAll("render_processing [name] > done[time_spent]")
        .forEach(handleRenderProcessingTime);
}

export default function serversidetimings(_moduleValue) {
    getData().then(parseXml).then(renderUI).catch(console.error);
}
